import React from 'react';

import { type GatsbyBrowser, Script } from 'gatsby';
import { setupCookieSync, isBrowser, isDev, scripts, getCookie } from '@lucid/utils';

const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
  const maxAttempts = 3;
  let attempt = 0;
  let { pathname } = window.location;

  if (pathname === '/' || pathname === 'pages/') {
    pathname = 'homepage';
  }

  const recordPage = () => {
    try {
      if (window.lucid && window.lucid.beacon) {
        window.lucid.beacon.recordPageChange(location.href);
      }
    } catch (e) {
      if (attempt < maxAttempts) {
        attempt += 1;
        setTimeout(() => recordPage(), 100);
      } else {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  };

  if (prevLocation && !(prevLocation as Location).pathname.includes('/contact/')) {
    // set session storage so we can use it on single page marketo form
    try {
      sessionStorage.setItem('previousPageviewId', getCookie('lt-pageview-id') || '');
      sessionStorage.setItem('prevLocation', (prevLocation as Location).pathname);
    } catch {
      console.info('Unable to set session storage');
    }
  }

  if (isBrowser()) {
    if (prevLocation && window.lucid && window.lucid.beacon && !!window.lucid.beacon.recordPageChange) {
      setTimeout(() => recordPage(), 200);
    }

    if ('qualified' in window) {
      window.qualified('page');
    }
  }
};

const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  const iframeLocation = (window && window.location) || null;

  const { href, search } = window.location;

  if (window.dataLayer) {
    window.dataLayer.push({ originalLocation: href });
  }

  if (search.includes('showEditLink=1')) {
    window.localStorage.setItem('showEditLink', '1');
  }

  setupCookieSync(iframeLocation);
};

const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => {
  if ('qualified' in window || isDev()) {
    return element;
  }

  return (
    <React.Fragment>
      {element}
      <Script key="qualified-init" id="qualified-init" strategy="idle">
        {scripts.qualified}
      </Script>
      <Script
        key="qualified-external"
        async
        id="qualified-external"
        src="https://js.qualified.com/qualified.js?token=gtGrXHe9GAjt2evZ"
        strategy="idle"
      />
    </React.Fragment>
  );
};

export { onRouteUpdate, onInitialClientRender, wrapPageElement };
